import { render, staticRenderFns } from "./GNotFound.vue?vue&type=template&id=3f091517&scoped=true&"
import script from "./GNotFound.vue?vue&type=script&lang=ts&"
export * from "./GNotFound.vue?vue&type=script&lang=ts&"
import style0 from "./GNotFound.vue?vue&type=style&index=0&id=3f091517&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f091517",
  null
  
)

export default component.exports